import { UseQueryArgs, useQuery } from 'urql';

import useStore from './useStore';

export default function useSiteQuery<T>(params: UseQueryArgs) {
  const { site } = useStore('globals');
  const variables = { site, ...params.variables };
  return useQuery<T>({ ...params, variables });
}
